import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { workerService } from 'js/services/worker.service';

import * as actions from '../store/actions';

export const useGetMenuItems = () => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const formFactor = useDeviceSelector(prop('formFactor'));
    const requestStamp = useAppSelector(prop('requestStamp'));

    useEffect(() => {
        if (!lang || !formFactor) {
            return;
        }
        const requestURL = getCMSResourceURL(`/initialResources/menu/${lang}_${formFactor}`, { t: requestStamp });

        workerService.request('json', requestURL)
            .then(({ menuItems }) => {
                dispatcher.dispatch('menu:items', menuItems);
                dispatch(actions.updateMenuItems(menuItems));
            });
    }, [dispatch, lang, formFactor, requestStamp, getCMSResourceURL]);
};
